import { ContentItem } from '@kentico/kontent-delivery';
import get from 'lodash/get';
import { ICircleFeatureCardProps } from '../components/circle-feature-card/circle-feature-card';

export class CircleFeatureModel extends ContentItem {
  get content(): string {
    return get(this._config, 'elements.circle_feature_card__content.value', '');
  }
  get ico(): string {
    return get(this._config, 'elements.material_icons.value[0].name', '');
  }
  get isVertical(): boolean {
    return get(this._config, 'elements.verticle_element.value') === 'true';
  }

  public static create(data: ICircleFeatureCard): ICircleFeatureCardProps {
    const { content, ico, isVertical } = new CircleFeatureModel(data);
    return {
      data: {
        content,
        ico
      },
      isVertical
    };
  }
}
